module.exports = __webpack_public_path__ + "static/03-4c7a60ca167203bdc64c22e54cc52707.jpg";